import axios from 'axios';

const ROOT = 'api/v1/workbook';

const PMWorkBookApi = {
  getWorkBookData() {
    return axios.get(`${ROOT}/`);
  },
  updateCell(request) {
    return axios.patch(`${ROOT}/cell`, request);
  }
};

export default PMWorkBookApi;
